<template>
    <div class="middlepage">
        <img class="background-image" :src="preText + bgImg" alt="">
        <!-- 1-1 -->
        <div class="item-wrapper item-1-1">
            <img class="item-img" v-img-lazy="preText + itemList[0].img_item" alt="">
            <div class="item-cover">
                <div class="qrcode-wrapper qrcode-1-1">
                    <img class="qrcode-img-1-1" v-img-lazy="preText + itemList[0].img_qrcode" alt="">
                </div>
            </div>
        </div>
        <!-- 1-2 -->
        <div class="item-wrapper item-1-2">
            <img class="item-img" v-img-lazy="preText + itemList[1].img_item" alt="">
            <div class="item-cover">
                <div class="qrcode-wrapper qrcode-1-2">
                    <img class="qrcode-img-1-2" v-img-lazy="preText + itemList[1].img_qrcode" alt="">
                </div>
            </div>
        </div>
        <!-- 2-1 -->
        <div class="item-wrapper item-2-1 row2-common">
            <img class="item-img" v-img-lazy="preText + itemList[2].img_item" alt="">
            <div class="item-cover">
                <div class="qrcode-wrapper qrcode-2">
                    <img class="qrcode-img-2" v-img-lazy="preText + itemList[2].img_qrcode" alt="">
                </div>
            </div>
        </div>
        <!-- 2-2 -->
        <div class="item-wrapper item-2-2 row2-common">
            <img class="item-img" v-img-lazy="preText + itemList[3].img_item" alt="">
            <div class="item-cover">
                <div class="qrcode-wrapper qrcode-2">
                    <img class="qrcode-img-2" v-img-lazy="preText + itemList[3].img_qrcode" alt="">
                </div>
            </div>
        </div>
        <!-- 2-3 -->
        <div class="item-wrapper item-2-3 row2-common">
            <img class="item-img" v-img-lazy="preText + itemList[4].img_item" alt="">
            <div class="item-cover">
                <div class="qrcode-wrapper qrcode-2">
                    <img class="qrcode-img-2" v-img-lazy="preText + itemList[4].img_qrcode" alt="">
                </div>
            </div>
        </div>
        <!-- 2-4 -->
        <div class="item-wrapper item-2-4 row2-common">
            <img class="item-img" v-img-lazy="preText + itemList[5].img_item" alt="">
            <div class="item-cover">
                <div class="qrcode-wrapper qrcode-2">
                    <img class="qrcode-img-2" v-img-lazy="preText + itemList[5].img_qrcode" alt="">
                </div>
            </div>
        </div>
    </div>
  </template>
  
  <script>
  import { isPortraitFun } from "@/utils/utils.js";
  
  export default {
    name: 'part-right',
    props: {
      itemList: {
        type: Array,
        required: true,
        default: () => []
      },
      bgImg: {
        type: String,
        required: true,
        default: ''
      }
    },
    data() {
      return {
        isPortrait: isPortraitFun(),
        preText:'https://www.kia.cn',
      };
    },
    mounted: function () {
      if (!window.location.href.includes("https://www.kia.cn")) {
        this.preText = 'https://uat.kia.cn'
      }else{
        this.preText = 'https://www.kia.cn'
      }
    },
    methods: {
      
    },
  };
  </script>
  
  <style lang="scss" scoped>
  
  
  @media (min-width: 767px) {
    .middlepage {
        position: relative;
        width: 100%;
        // aspect-ratio: 1920 / 1064;
        height: calc(1064 / 1920 * 100vw);
        user-select: none;
        z-index: 0;
    }
    .background-image {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .item-wrapper {
        position: absolute;
    }
    .item-img {
        position: relative;
        width: 100%;
        height: 100%;
        z-index: 1;
        border-radius: calc(17.66 / 1920 * 100vw);
    }
    .item-cover {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(86, 86, 86, 0.8);
        border-radius: calc(17.66 / 1920 * 100vw);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10;
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.3s ease;
    }
    .item-wrapper:hover .item-cover {
        opacity: 1;
        pointer-events: auto;
    }
    .row2-common{
        top: calc(677.57 / 1920 * 100vw);
        width: calc(251.56 / 1920 * 100vw);
        height: calc(251.56 / 1920 * 100vw); 
    }
    .item-1-1 {
        top: calc(202 / 1920 * 100vw);
        left: calc(562 / 1920 * 100vw);
        width: calc(722.8 / 1920 * 100vw);
        height: calc(459.19 / 1920 * 100vw);
    }
    .item-1-2 {
        top: calc(344.9 / 1920 * 100vw);
        left: calc(1305 / 1920 * 100vw);
        width: calc(316.63 / 1920 * 100vw);
        height: calc(316.63/ 1920 * 100vw);
    }
    .item-2-1 {
        left: calc(562 / 1920 * 100vw);
    }
    .item-2-2 {
        left: calc(831 / 1920 * 100vw);
    }
    .item-2-3 {
        left: calc(1099 / 1920 * 100vw);
    }
    .item-2-4 {
        left: calc(1367 / 1920 * 100vw);
    }
    .qrcode-common {
        z-index: 11;
    }
    .qrcode-1-1 {
        width: calc(207 / 1920 * 100vw);
        height: calc(207 / 1920 * 100vw);
        border-radius: calc(10 / 1920 * 100vw);
    }
    .qrcode-img-1-1 {
        width: calc(179 / 1920 * 100vw);
        height: calc(179 / 1920 * 100vw);
        border-radius: calc(10 / 1920 * 100vw);
    }
    .qrcode-1-2 {
        width: calc(168 / 1920 * 100vw);
        height: calc(168 / 1920 * 100vw);
        border-radius: calc(8 / 1920 * 100vw);
    }
    .qrcode-img-1-2 {
        width: calc(145 / 1920 * 100vw);
        height: calc(145 / 1920 * 100vw);
        border-radius: calc(8 / 1920 * 100vw);
    }
    .qrcode-2 {
        width: calc(133 / 1920 * 100vw);
        height: calc(133 / 1920 * 100vw);
        border-radius: calc(6.43 / 1920 * 100vw);
    }
    .qrcode-img-2 {
        width: calc(115 / 1920 * 100vw);
        height: calc(115 / 1920 * 100vw);
        border-radius: calc(6.43 / 1920 * 100vw);
    }
    .qrcode-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(20, 20, 20, 0.2);
        border: 0.81px solid rgba(192, 157, 90, 1)
    }
}
  </style>